var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search"},[_c('div',{staticClass:"container-fluid"},[_c('keyword-search',{attrs:{"initialValue":_vm.initialValue},on:{"searchWordChanged":_vm.searchWordChanged}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }